import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class JobService {
  urlAll = `${ environment.apiRoot }/job-all-v2/`;
  urlCompany = `${ environment.apiRoot }/company-all-v2/`;
  urlCity = `${ environment.apiRoot }/job-company-v2/`;
  constructor(
    public http: Http
  ) { }

  createRequestHeaders(headers: Headers, userId?: string) {
    headers.set('Content-Type', 'application/json');
    headers.set('X-API-KEY', environment.apiKey);
  }

  public getJobAll(lat: number, lng: number, urgent?: number, page?: number, q?: string, pageofer?:string) {
    const headers = new Headers();
    this.createRequestHeaders(headers);
    const params: URLSearchParams = new URLSearchParams();

    params.set('lat', String(lat));
    if (urgent != undefined) {
      params.set('urgent', String(urgent) );
    }
    if (page == undefined) {
      params.set('page', '1' );
    } else {
      params.set('page', String(page) );
    }

    if (q != undefined) {
      params.set('q', q );
    }
    params.set('lng', String(lng));
    
    //si es el espectador se cambia la cantidad de ofertas a mostar
    if (pageofer == '2'){
      params.append('pagecount', '2');
    }else{
      params.append('pagecount', '6');
    }
    
    params.append('app', '0');
    const options = {headers: headers, params: params};

    return new Promise((resolve, reject) => {
        this.http.get(this.urlAll, options)
          .subscribe(res => {
            resolve(res.json().data);
          }, (err) => {
            console.log(err);
            reject(err.json().meta.message);
        });
    });
  }

  public getJobAll4(lat: number, lng: number, urgent?: number, page?: number, q?: string) {
    const headers = new Headers();
    this.createRequestHeaders(headers);
    const params: URLSearchParams = new URLSearchParams();

    params.set('lat', String(lat));
    if (urgent != undefined) {
      params.set('urgent', String(urgent) );
    }
    if (page == undefined) {
      params.set('page', '1' );
    } else {
      params.set('page', String(page) );
    }

    if (q != undefined) {
      params.set('q', q );
    }
    params.set('lng', String(lng));
    params.append('pagecount', '3');
    params.append('app', '0');
    const options = {headers: headers, params: params};

    return new Promise((resolve, reject) => {
        this.http.get(this.urlAll, options)
          .subscribe(res => {
            resolve(res.json().data);
          }, (err) => {
            console.log(err);
            reject(err.json().meta.message);
        });
    });
  }

  public getJobCompany(lat: number, lng: number, page?: number, q?: string) {
    const headers = new Headers();
    this.createRequestHeaders(headers);
    const params: URLSearchParams = new URLSearchParams();

    params.set('lat', String(lat));

    if (page != undefined) {
      params.set('page', String(page) );
    } else {
      params.set('page', String(page) );
    }
    params.set('lng', String(lng));
    params.set('r', '5');
    if (q != undefined) {
      params.set('q', q );
    }

    const options = {headers: headers, params: params};

    return new Promise((resolve, reject) => {
        this.http.get(this.urlCompany, options)
          .subscribe(res => {
            resolve(res.json().data);
          }, (err) => {
            console.log(err);
            reject(err.json().meta.message);
        });
    });
  }

  public getJobCity(lat: number, lng: number, id: string, page?: number) {
    const headers = new Headers();
    this.createRequestHeaders(headers);
    const params: URLSearchParams = new URLSearchParams();

    params.set('lat', String(lat));
    params.set('company_id', id);

    if (page != undefined) {
      params.set('page', String(page) );
    } else {
      params.set('page', String(page) );
    }
    params.set('lng', String(lng));
    params.set('r', '5');

    const options = {headers: headers, params: params};

    return new Promise((resolve, reject) => {
        this.http.get(this.urlCity, options)
          .subscribe(res => {
            resolve(res.json().data);
          }, (err) => {
            console.log(err);
            reject(err.json().meta.message);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/job.service.ts